import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useStyles from '../../../theme/useStyles';
import { IconButton, Menu, MenuItem } from '@mui/material';
import FichaPropertyDialog from '../../objects/FichaPropertyDialog';
import RatingForm from '../../objects/RatingForm';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';


const MenuProperty = ({ verEvento, dataItem, handleDataUpdate}) => {
    const { isLoggedIn, username } = useSelector((state) => state.session);
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogRating, setOpenDialogRating] = useState(false);
    const navigate = useNavigate()


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
        handleClose();
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleOpenDialogRating = () => {
        setOpenDialogRating(true);
        handleClose();
    };

    const handleCloseDialogRating = () => {
        setOpenDialogRating(false);
    };
    
    const handleEditProperty = () => {
        if (!isLoggedIn) {
            Swal.fire({
                title: 'Acceso restringido',
                text: 'Debes iniciar sesión para editar una propiedad',
                icon: 'warning',
                confirmButtonText: 'Ir a login',
                showCancelButton: true,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/login');
                }
            });
            handleClose();
            return;
        }
        verEvento(dataItem);
        handleClose();
    };
    
    return (
        <div>
            <IconButton
                className={classes.menuButton}
                aria-controls="floating-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="floating-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={handleOpenDialog} style={{ fontSize: '0.875rem', fontWeight: 400 }}>Ver detalles</MenuItem>
                <MenuItem onClick={handleOpenDialogRating} style={{ fontSize: '0.875rem', fontWeight: 400 }}>Calificar</MenuItem>
                {/* <MenuItem onClick={handleClose} style={{ fontSize: '0.875rem', fontWeight: 400 }}>Ver comentarios</MenuItem> */}
                {/* <MenuItem onClick={() => { verEvento(dataItem); handleClose(); }} style={{ fontSize: '0.875rem', fontWeight: 400 }}>Editar Propiedad</MenuItem>  */}
                <MenuItem onClick={handleEditProperty} style={{ fontSize: '0.875rem', fontWeight: 400 }}>Editar Propiedad</MenuItem> 
                {/* ADMIN */}
                {/* {isAdmin && (
                    <MenuItem onClick={() => { verEvento(dataItem); handleClose(); }} style={{ fontSize: '0.875rem', fontWeight: 400 }}>Editar Evento</MenuItem> 
                )} */}
                {/* FIN ADMIN */}
            </Menu>
            <FichaPropertyDialog open={openDialog} handleClose={handleCloseDialog} data={dataItem} />

            <RatingForm open={openDialogRating} handleClose={handleCloseDialogRating} propertyId={dataItem.id} propertyName={dataItem.name} handleDataUpdate={handleDataUpdate}/>

        </div>
    );
};

export default MenuProperty;
